
import { defineComponent, ref, PropType } from 'vue';

interface menuListStd {
  children: menuListStd,
  selected: boolean,
  path: string,
  name: string,
  meta: any,
}

export default defineComponent({
  name: 'MenuTreeNode',
  props: {
    menuList: Array as PropType<menuListStd[]>,
    distanceIndex: Number,
    collapsed: Boolean,
  },
  setup(props, context) {
    const handleClick = (path) => {
      context.emit('handleClick', path);
    };
    return {
      props,
      handleClick,
    };
  },
});
